/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Popup from 'reactjs-popup';
import MuiAlert from '@material-ui/lab/Alert';
import 'reactjs-popup/dist/index.css';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import moment from 'moment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Paper from '@material-ui/core/Paper';
import myFirebase from 'firebase';
import Button from '@material-ui/core/Button';
import firebase from '../../../config/config';
import FeatureFlagEmptyState from '../../Components/FeatureFlagEmptyState';
import logger from '../../../utils/logger.js';
import {
  deleteFileHandlerNew,
  fileUploaderNew,
  getSignedURLNew,
  getViewURLNew,
} from '../../../utils/fileUploadHandler';
import convertTimestampToDate from '../../../utils/convertTimestampToDate';
import { mappedCurrentActiveRole } from '../../../utils/roleMapping.js';

const useStyles = makeStyles({
  box: {
    borderRadius: '5px',
    textAlign: 'left',
    border: '2px dashed',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  viewButton: {
    background: '#52BE56',
    color: 'white',
    margin: '0px 10px 0px 0px',
    padding: '5px 10px',
  },
  nameTabs: {
    display: 'flex',
    flexDirection: 'column',
  },
  promptBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alert: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '2px dashed lightgray',
    borderRadius: '5px',
  },
  deleteModalButton: {
    width: '45%',
    background: '#52BE56',
    borderRadius: 0,
    color: 'white',
    margin: '5px',
  },
  cancelButton: {
    width: '45%',
    background: 'lightgray',
    borderRadius: 0,
    margin: '5px',
  },
});
const contentStyle = { width: '24%' };
const inlineCheckIconStyle = {
  color: '#52BE56',
};

const nameBoxStyles = {
  display: 'flex',
  margin: '10px 0px 0px 8px',
  gap: '5px',
  alignItems: 'center',
};
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const paperStyles = { padding: 10 };
const PANFileUpload = ({
  truckerId,
  activeRole,
  multiStep,
  featureFlagFiles,
  panFileUploaded,
  fileDetails,
  refetch,
}) => {
  const {
    pan_file_path: isPanAvailable,
    pan_uploaded_by: uploadedBy,
    pan_uploaded_at: uploadedAt,
  } = fileDetails || {};
  const [loading, setLoading] = useState(false);
  const [user, setUser] = React.useState();
  const [success, setSuccess] = useState(false);
  const [deleted, setDeleted] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const db = firebase.firestore();
  const classes = useStyles();
  const auditLog = firebase.functions().httpsCallable('utilities-auditLog');

  function fileS3Uploader(UploadedFile) {
    const body = {
      file_type: 'trucker_pan',
      trucker_id: truckerId,
      role: mappedCurrentActiveRole(activeRole),
    };
    getSignedURLNew(body, UploadedFile)
      .then(response => {
        const { url: signedURL, metadata } = response?.data;
        fileUploaderNew(signedURL, metadata, UploadedFile)
          .then(res => {
            setTimeout(() => {
              refetch();
              setOpen(false);
            }, 4000);
          })
          .catch(e => {
            setOpen(false);
            panFileUploaded(false);
          });
      })
      .catch(e => setOpen(false));
  }

  const onDrop = async acceptedFiles => {
    setOpen(!open);
    // Do something with the files
    const UploadedFile = acceptedFiles[0];
    if (featureFlagFiles === 2) {
      fileS3Uploader(UploadedFile);
    } else if (featureFlagFiles === 0) {
      const podRef = await db.collection('FileUploads');
      const storageRef = myFirebase
        .storage()
        .ref(`Trucker_Files/PAN/${truckerId}`);
      const task = storageRef.put(UploadedFile);
      task.on(
        'state_changed',
        snapshot => {
          const percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if (percentage === 100) {
            setOpen(false);
          }
        },
        error => {
          logger.error(error);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          task.snapshot.ref.getDownloadURL().then(downloadURL => {
            podRef
              .doc('TruckerFiles')
              .collection('PAN')
              .doc(truckerId)
              .set(
                {
                  PANUpdatedByName: user.displayName,
                  PANUpdatedByUid: user.uid,
                  PANUpdatedAT: moment().format('llll'),
                  PANFileUploadURL: downloadURL,
                },
                { merge: true }
              );
            panFileUploaded(true);

            const auditBody = {
              // data: { ...transaction },
              collection: 'file uploads',
              panFileUploadedBy: user.uid,
              type: 'Uploaded PAN File in Truckers',
              message: `${user.email} in file uploads collection inside transporterfile doc inside PAN collection with ${truckerId} transporter ID uploaded the file `,
              uploadedAt: moment().format('llll'),
            };
            auditLog(auditBody);
            setSuccess(true);
          });
        }
      );
    }
  };
  // -----------------//

  async function HandleDelete() {
    const body = {
      scope: 'trucker',
      file_type: 'PAN',
      org_id: truckerId,
      role: mappedCurrentActiveRole(activeRole),
    };
    try {
      await deleteFileHandlerNew(body);

      setOpen(false);
      setDeleted(true);
      refetch();
      const auditBody = {
        collection: 'Truckers',
        podFileDeletedBy: user.uid,
        type: 'Delete PAN File in Truckers',
        message: `${user.email} in Truckers with ${truckerId} trucker ID deleted the file `,
        deletedAt: new Date(),
      };
      auditLog(auditBody);
    } catch (e) {
      logger.error(e);
      setOpen(false);
    }
  }
  async function DeleteLRFile() {
    setOpen(true);
    if (featureFlagFiles === 2) {
      HandleDelete();
    } else {
      const storageRef = myFirebase
        .storage()
        .ref('Trucker_Files/PAN')
        .child(truckerId);
      storageRef.delete().then(() => {
        const podRef = db.collection('FileUploads');
        podRef
          .doc('TruckerFiles')
          .collection('PAN')
          .doc(truckerId)
          .delete();

        const auditBody = {
          // data: { ...transaction },
          collection: 'Truckers',
          podFileDeletedBy: user.uid,
          type: 'Delete PAN File in Truckers',
          message: `${user.email} in Truckers with ${truckerId} trucker ID deleted the file `,
          deletedAt: new Date(),
        };
        auditLog(auditBody);
        setOpen(false);
        setDeleted(true);
      });
    }
  }
  function handleClose() {
    setDeleted(false);
    setSuccess(false);
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    acceptedFiles: {
      'image/png': ['.png', '.jpeg', '.jpg'],
      'application/pdf': ['.pdf'],
    },
  });
  const viewFile = url => {
    window.open(url);
  };

  function handleGetPanData() {
    setLoading(true);
    const viewURLBody = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'trucker_pan',
      trucker_id: truckerId,
    };
    getViewURLNew(viewURLBody)
      .then(result => {
        viewFile(result?.data?.file_details?.url);
        setLoading(false);
      })
      .catch(e => {
        logger.error('error', e);
        setLoading(false);
      });
  }

  function getPanData() {
    if (featureFlagFiles === 2) {
      handleGetPanData();
    } else if (featureFlagFiles === 0) {
      const docRef = db
        .collection('FileUploads')
        .doc('TruckerFiles')
        .collection('PAN')
        .doc(truckerId);
      // .collection('PAN')
      // .doc(truckerId);

      docRef
        .get()
        .then(doc => {
          if (doc.exists) {
            const data = doc.data();
            refetch();
          }
        })
        .catch(error => {
          logger.error('Error getting document:', error);
        });
    }
  }

  useEffect(() => {
    const userDetails = firebase.auth().currentUser;
    setUser(userDetails);
  }, []);

  return (
    <Paper elevation={1} style={paperStyles}>
      {featureFlagFiles === 0 ||
        (featureFlagFiles === 2 && (
          <>
            {(activeRole == 'sales' ||
              activeRole == 'branch-ops' ||
              activeRole == 'traffic' ||
              multiStep) && (
              <>
                <div className={classes.headerWrapper}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p
                      style={{
                        margin: '8px',
                        textAlign: 'left',
                        fontSize: '20px',
                        fontWeight: 400,
                      }}
                    >
                      PAN
                    </p>
                    {isPanAvailable && (
                      <CheckCircleIcon
                        style={inlineCheckIconStyle}
                        fontSize="small"
                      />
                    )}
                  </div>

                  {isPanAvailable && (
                    <Box>
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        className={classes.viewButton}
                        onClick={() => getPanData()}
                        startIcon={<VisibilityIcon />}
                        disabled={loading}
                      >
                        View {loading && <CircularProgress size={8} />}
                      </Button>
                    </Box>
                  )}
                </div>
                <Box>
                  {!isPanAvailable ? (
                    <Box className={classes.container}>
                      {open ? (
                        <CircularProgress
                          style={{ color: '#FCD21F', margin: '5px' }}
                          size={30}
                          thickness={8}
                        />
                      ) : (
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              flexDirection: 'column',
                              marginTop: 5,
                            }}
                          >
                            <CloudUploadIcon />
                            <p
                              style={{
                                fontSize: '10px',
                                color: 'gray',
                                margin: 0,
                              }}
                            >
                              Drag and Drop or Click here to upload
                            </p>
                          </div>
                        </div>
                      )}
                    </Box>
                  ) : (
                    <div style={nameBoxStyles}>
                      <p
                        style={{
                          fontWeight: 'bold',
                          margin: 0,
                          fontSize: '12px',
                        }}
                      >
                        {uploadedBy}
                      </p>
                      <CircleIcon style={{ fontSize: '10px' }} />
                      <p
                        style={{
                          color: '#a9a9a9',
                          fontSize: '10px',
                          margin: 0,
                        }}
                      >
                        {convertTimestampToDate(uploadedAt)}
                      </p>
                    </div>
                  )}
                </Box>
              </>
            )}
            {(activeRole == 'ops' ||
              activeRole === 'approval' ||
              activeRole == 'finance' ||
              activeRole == 'finance-payable' ||
              activeRole == 'finance-recievable' ||
              activeRole == 'finance-recon' ||
              activeRole == 'partner-exec-manager') && (
              <Box>
                {!isPanAvailable ? (
                  <div>
                    <p
                      style={{
                        margin: '8px',
                        textAlign: 'left',
                        fontSize: '20px',
                        fontWeight: 400,
                      }}
                    >
                      Pan Card
                    </p>
                    <p style={{ margin: '0 0 10px 8px' }}>No File Uploaded </p>
                  </div>
                ) : (
                  <div className={classes.headerWrapper}>
                    <div className={classes.nameTabs}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <p
                          style={{
                            margin: '8px',
                            textAlign: 'left',
                            fontSize: '20px',
                            fontWeight: 400,
                          }}
                        >
                          PAN
                        </p>
                        {isPanAvailable && (
                          <CheckCircleIcon
                            style={inlineCheckIconStyle}
                            fontSize="small"
                          />
                        )}
                        {open && (
                          <CircularProgress
                            style={{ color: '#FCD21F', margin: '5px' }}
                            size={30}
                            thickness={8}
                          />
                        )}
                      </div>
                      <div style={nameBoxStyles}>
                        <p
                          style={{
                            fontWeight: 'bold',
                            margin: 0,
                            fontSize: '12px',
                          }}
                        >
                          {uploadedBy}
                        </p>
                        <CircleIcon style={{ fontSize: '10px' }} />
                        <p
                          style={{
                            color: '#a9a9a9',
                            fontSize: '10px',
                            margin: 0,
                          }}
                        >
                          {convertTimestampToDate(uploadedAt)}
                        </p>
                      </div>
                    </div>
                    {isPanAvailable && (
                      <Box>
                        <div className={classes.promptBox}>
                          <Button
                            variant="contained"
                            color="success"
                            size="small"
                            className={classes.viewButton}
                            onClick={() => getPanData()}
                            startIcon={<VisibilityIcon />}
                            disabled={loading}
                          >
                            View {loading && <CircularProgress size={5} />}
                          </Button>
                          {(activeRole === 'ops' ||
                            activeRole === 'approval') && (
                            <Popup
                              trigger={
                                <IconButton
                                  color="primary"
                                  aria-label="upload picture"
                                  component="span"
                                  size="small"
                                >
                                  <DeleteOutlineIcon color="error" />
                                </IconButton>
                              }
                              modal
                              {...{
                                contentStyle,
                              }}
                            >
                              {close => (
                                <div
                                  style={{
                                    padding: '10px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                  }}
                                >
                                  <HighlightOffIcon
                                    fontSize="large"
                                    color="error"
                                  />
                                  <h4 style={{ fontWeight: 'bold' }}>
                                    Are You Sure?
                                  </h4>
                                  <p>
                                    If you proceed, you will not be able to
                                    recover it
                                  </p>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      width: '100%',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <Button
                                      onClick={close}
                                      className={classes.cancelButton}
                                    >
                                      No
                                    </Button>
                                    <Button
                                      onClick={DeleteLRFile}
                                      className={classes.deleteModalButton}
                                      disabled={deleted}
                                    >
                                      Yes
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </Popup>
                          )}
                        </div>
                      </Box>
                    )}
                  </div>
                )}
              </Box>
            )}
            <Snackbar
              open={deleted}
              autoHideDuration={6000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="error">
                Deleted File!
              </Alert>
            </Snackbar>
            <Snackbar
              open={success}
              autoHideDuration={6000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="success">
                Uploaded File!
              </Alert>
            </Snackbar>
          </>
        ))}
      {featureFlagFiles === 1 && <FeatureFlagEmptyState color="black" />}
    </Paper>
  );
};

export default PANFileUpload;
